import { Outlet } from "react-router-dom"
import NavBar from "./navbar"

export function Layout({isAuthenticated}) {
    return (
        <div>
            <NavBar isAuthenticated={isAuthenticated}/>
            <div className="container">
                <Outlet />
            </div>
        </div>
    )
}